import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import TimeSlotServices from '../../services/TimeSlotServices';

function AddTimeSlot() {
  const navigate = useNavigate();
  
  const [formValues, setFormValues] = useState({
    day: '',
    timeSlots: []
  });

  const timeOptions = [
    "07:00 AM", "07:30 AM", "08:00 AM", "08:30 AM", "09:00 AM", "09:30 AM", 
    "10:00 AM", "10:30 AM", "11:00 AM", "11:30 AM", "12:00 PM", "12:30 PM",
    "01:00 PM", "01:30 PM", "02:00 PM", "02:30 PM", "03:00 PM", "03:30 PM",
    "04:00 PM", "04:30 PM", "05:00 PM", "05:30 PM", "06:00 PM", "06:30 PM",
    "07:00 PM", "07:30 PM", "08:00 PM"
  ];

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setFormValues((prevValues) => {
      const timeSlots = checked
        ? [...prevValues.timeSlots, value]
        : prevValues.timeSlots.filter((slot) => slot !== value);
      return { ...prevValues, timeSlots };
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await TimeSlotServices.createTime(formValues);
      alert('TimeSlot created successfully');
      navigate('/time-slot');
    } catch (error) {
      console.error('Failed to create TimeSlot', error);
      alert('Failed to create TimeSlot');
    }
  };

  return (
    <>
      <div className="right_col" role="main">
        <div className="title-box">
          <h2>Time Slot Manager</h2>
          <div className="container-box-top-header-right">
            <Link className="list-banner-btn" to="/time-slot">List Schedule</Link>
          </div>
        </div>
        <div className="container-box px-5">
          <div className="container-box-inner table-reponsive-tabe">
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                <div className="input-field">
                  <label>Day</label>
                  <input 
                    type="text" 
                    name="day" 
                    value={formValues.day} 
                    onChange={handleInputChange} 
                    className="form-control" 
                    placeholder="Day" 
            
                  />
                </div>

                <div className="col-md-6">
                  <div className="check-box-outer d-flex flex-wrap" style={{ gap: "20px" }}>
                    {timeOptions.map((time, index) => (
                      <div className="form-check" key={index}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value={time}
                          checked={formValues.timeSlots.includes(time)}
                          onChange={handleCheckboxChange}
                          id={`timeSlot-${index}`}
                        />
                        <label className="form-check-label" htmlFor={`timeSlot-${index}`}>
                          {time}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>

                <button className="submit-green-btn">SUBMIT</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddTimeSlot;
